import React, { useContext } from "react";
import * as PropTypes from "prop-types";

import { buyNowContext } from "../BuyNow";
import trackingScripts from "../../utils/trackingScripts";
import { createScaleObject, FACEBOOK_EVENTS } from "../../utils/facebookHelper";

const NON_BREAKING_SPACE = "\u00A0";

const DeviceChoice = (props) => {
  const deviceName = props.device.name.replace("Shapa Scale - ", "");
  const subText = props.device.subText;
  const { isProduction } = useContext(buyNowContext);
  const fbTrackingScaleObject = createScaleObject(props.device);

  return (
    <div className="col-6 mb-2 px-1" style={{ minHeight: "72px" }}>
      <button
        className={"h-100 col-12 btn btn-outline-dark toggle-button-outline description-txt py-3 py-lg-2 " + (props.isClicked ? 'clicked' : '')}
        onMouseOver={() => {
          props.onHovered(props.device)
          trackingScripts.facebook(isProduction, FACEBOOK_EVENTS.VIEW_CONTENT_SCALE, fbTrackingScaleObject, "trackCustom");
        }}
        onMouseOut={() => props.onHovered(null)}
        onClick={() => {
          props.onSelected(props.device);
          trackingScripts.facebook(isProduction, FACEBOOK_EVENTS.VIEW_CONTENT_SCALE, fbTrackingScaleObject, "trackCustom");
        }}
      >
        {deviceName}
      </button>

      {/* In some cases, we may want to display sub-text under the device option (ex. for refurbished MyClearStep scales, we may say 'Color may vary'. */}
      {subText &&
        <div className="plan-main-txt text-muted text-center font-italic" style={{marginTop: "5px"}}>
          {/* We only want the subtext to show when the device is selected. To keep the UI layout consistent, we'll render a blank space when the device isn't selected. */}
          {props.selectedDevice && props.selectedDevice.id === props.device.id ? subText : NON_BREAKING_SPACE}
        </div>
      }
    </div>
  );
};

DeviceChoice.propTypes = {
  device: PropTypes.object.isRequired,
  onSelected: PropTypes.func.isRequired,
  isClicked: PropTypes.bool.isRequired,
  selectedDevice: PropTypes.object
};

DeviceChoice.defaultProps = {
  selectedDevice: null
};

export default DeviceChoice;
